import { render, staticRenderFns } from "./StockPrintPkgTicketTplP.vue?vue&type=template&id=044bd994&scoped=true&"
import script from "./StockPrintPkgTicketTplP.vue?vue&type=script&lang=js&"
export * from "./StockPrintPkgTicketTplP.vue?vue&type=script&lang=js&"
import style0 from "./StockPrintPkgTicketTplP.vue?vue&type=style&index=0&id=044bd994&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044bd994",
  null
  
)

export default component.exports